export function debouncePromise<T extends (...args: any[]) => Promise<any>>(
  fn: T,
  delay: number,
): (...args: Parameters<T>) => Promise<Awaited<ReturnType<T>>> {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let rejectLast: ((reason?: any) => void) | null = null;

  return (...args: Parameters<T>): Promise<Awaited<ReturnType<T>>> => {
    if (timer) {
      clearTimeout(timer);
    }

    if (rejectLast) {
      rejectLast(new Error('Debounced'));
    }

    return new Promise<Awaited<ReturnType<T>>>((resolve, reject) => {
      rejectLast = reject;

      timer = setTimeout(async () => {
        try {
          const result = await fn(...args);
          resolve(result);
        } catch (err) {
          reject(err);
        }
      }, delay);
    });
  };
}
